<template>
  <div class="role-dialog">
    <el-dialog :title="title" :visible="dialogFormVisible" :show-close="false" width="45%">
      <el-form :model="form">
        <el-form-item label="教练名称">
          <el-input v-model="form.coachName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="教练介绍">
          <el-input v-model="form.autograph" type="textarea" :rows="3" placeholder="请输入教练介绍"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="$emit('cancel');">取 消</el-button>
        <el-button type="primary" :loading="btnLoading" @click="btnOk">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "RoleEdit",
  props: {
    dialogFormVisible: Boolean,
    data: [Object, Boolean],
    title: String
  },
  data() {
    return {
      form: {
        id: null,
        coachName: "",
        autograph: ""
      },
      btnLoading: false
    };
  },
  watch: {
    data: {
      handler: function() {
        if (this.data) {
          for (let k in this.form) {
            this.form[k] = this.data[k];
          }
        } else {
          for (let k in this.form) {
            this.form[k] = "";
          }
        }
      },
      deep: true
    }
  },
  created() {},
  methods: {
    handleChange() {},
    btnOk() {
      let that = this;
      let errorMsg = false;
      let formData = this.form;
      this.btnLoading = true;
      if (this.data) {
        this.editCoach(this.form);
      }else {
        this.addCoach();
      }
    },
    addCoach() {
      this.$axios
        .post(this.baseUrl + "/saveCoach", {
          coachName: this.form.coachName,
          autograph: this.form.autograph
        })
        .then(res => {
          this.btnLoading = false;
          this.$emit("cancel");
          this.$emit("getList");
        })
        .catch(error => {
          console.log(error);
        });
    },
    editCoach(data) {
      this.$axios
        .post(this.baseUrl + "/modifyCoach", data)
        .then(res => {
          this.btnLoading = false;
          this.$emit("cancel");
          this.$emit("getList");
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  components: {}
};
</script>
<style lang="less">
.role-dialog {
}
</style>
